//菜单：职务管理页面
import React from 'react'
import Manager from '../../public/components/Manager'
import JobDiv from '../SysManage/JobDiv'
Ext.require('Ext.Toast')

const config = {
    buttons: [
        {
            icon: 'plus', text: '添加...', handler: ({ showDetail, refreshPage }) =>
                Tyan.pubForm.showDialog('职务', props => <JobDiv {...props} id={-1} onSave={refreshPage} />)
        },
    ],
    columns: [
        { _text: '职务名称', minWidth: 150, flex: 1, locked: false },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        Tyan.pubForm.showDialog('职务', props => <JobDiv {...props} id={data.id} onSave={refreshPage} />)
    }
}

export default props => <Manager {...props} config={config} />